import * as React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  IconButton,
  withStyles,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import i18n from "i18n";

const styles = (theme) => ({
  title: { color: "#f2f2f2", fontSize: 18, margin: 0 },
  message: { color: "#a6a6a6", fontSize: 16, margin: 0 },
  closeIcon: {
    right: 20,
    top: 14,
  },
  confirmButton: {
    cursor: "pointer",
    padding: "8px 16px",
    color: theme.palette.primary.light,
  },
});

interface IProps {
  classes: any;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ExclusionDialog = ({
  classes,
  open = false,
  onClose = () => {},
  onConfirm = () => {},
}: IProps) => {
  const handleClose = () => {
    onClose();
  };

  const handleClickConfirm = async () => {
    await onConfirm();
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
    >
      <DialogTitle style={{ padding: 20 }}>
        <p className={classes.title}>{i18n.modelMaps.delete.title}</p>
        <IconButton
          onClick={handleClose}
          className={classes.closeIcon}
          style={{ position: "absolute" }}
        >
          <Close fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <DialogContentText style={{ padding: 0 }}>
          <p className={classes.message}>{i18n.modelMaps.delete.content}</p>
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          autoFocus
          className={classes.confirmButton}
          onClick={handleClickConfirm}
        >
          {i18n.yes}
        </Button>
        <Button onClick={handleClose} color="secondary">
          {i18n.no}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(ExclusionDialog);



// WEBPACK FOOTER //
// ./src/modules/modelMap/components/layouts/ExclusionDialog.tsx